//简易表达式--所有操作符
export const AllOperator: { lang: string, resource: { label: string, value: string }[] }[] = [
  {
    lang: "zh-CHS",
    resource: [
      {
        label: "大于",
        value: ">"
      },
      {
        label: "大于等于",
        value: ">="
      },
      {
        label: "等于",
        value: "=="
      },
      {
        label: "不等于",
        value: "!="
      },
      {
        label: "小于",
        value: "<"
      },
      {
        label: "小于等于",
        value: "<="
      },
      {
        label: "等于(字符串)",
        value: "equal"
      },
      {
        label: "不等于(字符串)",
        value: "notequal"
      },
      {
        label: "为空",
        value: "==null"
      },
      {
        label: "不为空",
        value: "!=null"
      },
      {
        label: "包含",
        value: "Contains"
      },
      {
        label: "不包含",
        value: "NotContains"
      },
      {
        label: "开头是",
        value: "StartsWith"
      },
      {
        label: "开头不是",
        value: "NotStartsWith"
      },
      {
        label: "结尾是",
        value: "EndsWith"
      },
      {
        label: "结尾不是",
        value: "NotEndsWith"
      },
      {
        label: "组织从属",
        value: "OrgAffiliation"
      }
    ]
  },
  {
    lang: "en",
    resource: [
      {
        label: "GreaterThan",
        value: ">"
      },
      {
        label: "GreaterOrEqual",
        value: ">="
      },
      {
        label: "Equal",
        value: "=="
      },
      {
        label: "NotEqual",
        value: "!="
      },
      {
        label: "LessThan",
        value: "<"
      },
      {
        label: "LessOrEqual",
        value: "<="
      },
      {
        label: "Equal(String)",
        value: "equal"
      },
      {
        label: "NotEqual(String)",
        value: "notequal"
      },
      {
        label: "IsNull",
        value: "==null"
      },
      {
        label: "NotNull",
        value: "!=null"
      },
      {
        label: "Contains",
        value: "Contains"
      },
      {
        label: "NotContains",
        value: "NotContains"
      },
      {
        label: "StartsWith",
        value: "StartsWith"
      },
      {
        label: "NotStartsWith",
        value: "NotStartsWith"
      },
      {
        label: "EndsWith",
        value: "EndsWith"
      },
      {
        label: "NotEndsWith",
        value: "NotEndsWith"
      },
      {
        label: "OrgAffiliation",
        value: "OrgAffiliation"
      }
    ]
  },
  {
    lang: "zh-CHT",
    resource: [
      {
        label: "大於",
        value: ">"
      },
      {
        label: "大於等於",
        value: ">="
      },
      {
        label: "等於",
        value: "=="
      },
      {
        label: "不等於",
        value: "!="
      },
      {
        label: "小於",
        value: "<"
      },
      {
        label: "小於等於",
        value: "<="
      },
      {
        label: "等於（字符）",
        value: "equal"
      },
      {
        label: "不等於（字符）",
        value: "notequal"
      },
      {
        label: "為空",
        value: "==null"
      },
      {
        label: "不為空",
        value: "!=null"
      },
      {
        label: "包含",
        value: "Contains"
      },
      {
        label: "不包含",
        value: "NotContains"
      },
      {
        label: "開頭是",
        value: "StartsWith"
      },
      {
        label: "開頭不是",
        value: "NotStartsWith"
      },
      {
        label: "結尾是",
        value: "EndsWith"
      },
      {
        label: "結不尾是",
        value: "NotEndsWith"
      },
      {
        label: "組織從屬",
        value: "OrgAffiliation"
      }
    ]
  }
];
//字符型操作符
export const StringOperator: { lang: string, resource: { label: string, value: string }[] }[] = [
  {
    lang: "zh-CHS",
    resource: [
      {
        label: "等于(字符串)",
        value: "equal"
      },
      {
        label: "不等于(字符串)",
        value: "notequal"
      },
      {
        label: "为空",
        value: "==null"
      },
      {
        label: "不为空",
        value: "!=null"
      },
      {
        label: "包含",
        value: "Contains"
      },
      {
        label: "不包含",
        value: "NotContains"
      },
      {
        label: "开头是",
        value: "StartsWith"
      },
      {
        label: "开头不是",
        value: "NotStartsWith"
      },
      {
        label: "结尾是",
        value: "EndsWith"
      },
      {
        label: "结尾不是",
        value: "NotEndsWith"
      },
      {
        label: "组织从属",
        value: "OrgAffiliation"
      }
    ]
  },
  {
    lang: "en",
    resource: [
      {
        label: "Equal(String)",
        value: "equal"
      },
      {
        label: "NotEqual(String)",
        value: "notequal"
      },
      {
        label: "IsNull",
        value: "==null"
      },
      {
        label: "NotNull",
        value: "!=null"
      },
      {
        label: "Contains",
        value: "Contains"
      },
      {
        label: "NotContains",
        value: "NotContains"
      },
      {
        label: "StartsWith",
        value: "StartsWith"
      },
      {
        label: "NotStartsWith",
        value: "NotStartsWith"
      },
      {
        label: "EndsWith",
        value: "EndsWith"
      },
      {
        label: "NotEndsWith",
        value: "NotEndsWith"
      },
      {
        label: "OrgAffiliation",
        value: "OrgAffiliation"
      }]
  },
  {
    lang: "zh-CHT",
    resource: [
      {
        label: "等於（字符）",
        value: "equal"
      },
      {
        label: "不等於（字符）",
        value: "notequal"
      },
      {
        label: "為空",
        value: "==null"
      },
      {
        label: "不為空",
        value: "!=null"
      },
      {
        label: "包含",
        value: "Contains"
      },
      {
        label: "不包含",
        value: "NotContains"
      },
      {
        label: "開頭是",
        value: "StartsWith"
      },
      {
        label: "開頭不是",
        value: "NotStartsWith"
      },
      {
        label: "結尾是",
        value: "EndsWith"
      },
      {
        label: "結尾不是",
        value: "NotEndsWith"
      },
      {
        label: "組織從屬",
        value: "OrgAffiliation"
      }
    ]
  }
];
//数字型操作符
export const NumberOperator: { lang: string, resource: { label: string, value: string }[] }[] = [
  {
    lang: "zh-CHS",
    resource: [
      {
        label: "大于",
        value: ">"
      },
      {
        label: "大于等于",
        value: ">="
      },
      {
        label: "等于",
        value: "=="
      },
      {
        label: "不等于",
        value: "!="
      },
      {
        label: "小于",
        value: "<"
      },
      {
        label: "小于等于",
        value: "<="
      },
      {
        label: "为空",
        value: "==null"
      },
      {
        label: "不为空",
        value: "!=null"
      },
      {
        label: "包含",
        value: "Contains"
      },
      {
        label: "不包含",
        value: "NotContains"
      },
      {
        label: "开头是",
        value: "StartsWith"
      },
      {
        label: "开头不是",
        value: "NotStartsWith"
      },
      {
        label: "结尾是",
        value: "EndsWith"
      },
      {
        label: "结尾不是",
        value: "NotEndsWith"
      },
      {
        label: "组织从属",
        value: "OrgAffiliation"
      }
    ]
  },
  {
    lang: "en",
    resource: [
      {
        label: "GreaterThan",
        value: ">"
      },
      {
        label: "GreaterOrEqual",
        value: ">="
      },
      {
        label: "Equal",
        value: "=="
      },
      {
        label: "NotEqual",
        value: "!="
      },
      {
        label: "LessThan",
        value: "<"
      },
      {
        label: "LessOrEqual",
        value: "<="
      },
      {
        label: "IsNull",
        value: "==null"
      },
      {
        label: "NotNull",
        value: "!=null"
      },
      {
        label: "Contains",
        value: "Contains"
      },
      {
        label: "NotContains",
        value: "NotContains"
      },
      {
        label: "StartsWith",
        value: "StartsWith"
      },
      {
        label: "NotStartsWith",
        value: "NotStartsWith"
      },
      {
        label: "EndsWith",
        value: "EndsWith"
      },
      {
        label: "NotEndsWith",
        value: "NotEndsWith"
      },
      {
        label: "OrgAffiliation",
        value: "OrgAffiliation"
      }
    ]
  },
  {
    lang: "zh-CHT",
    resource: [
      {
        label: "大於",
        value: ">"
      },
      {
        label: "大於等於",
        value: ">="
      },
      {
        label: "等於",
        value: "=="
      },
      {
        label: "不等於",
        value: "!="
      },
      {
        label: "小於",
        value: "<"
      },
      {
        label: "小於等於",
        value: "<="
      },
      {
        label: "為空",
        value: "==null"
      },
      {
        label: "不為空",
        value: "!=null"
      },
      {
        label: "包含",
        value: "Contains"
      },
      {
        label: "不包含",
        value: "NotContains"
      },
      {
        label: "開頭是",
        value: "StartsWith"
      },
      {
        label: "開頭不是",
        value: "NotStartsWith"
      },
      {
        label: "結尾是",
        value: "EndsWith"
      },
      {
        label: "結不尾是",
        value: "NotEndsWith"
      },
      {
        label: "組織從屬",
        value: "OrgAffiliation"
      }
    ]
  }
];
//关系操作符
export const RelationOperator: { lang: string, resource: { label: string, value: string }[] }[] = [
  {
    lang: "zh-CHS",
    resource: [
      {
        label: "并且",
        value: "&&"
      },
      {
        label: "或者",
        value: "||"
      }
    ]
  },
  {
    lang: "en",
    resource: [
      {
        label: "And",
        value: "&&"
      },
      {
        label: "Or",
        value: "||"
      }
    ]
  },
  {
    lang: "zh-CHT",
    resource: [
      {
        label: "並且",
        value: "&&"
      },
      {
        label: "或者",
        value: "||"
      }
    ]
  }
];
//左括号
export const LeftBracket: string[] = ["(", "((", "(((", "(((("];
//右括号
export const RightBracket: string[] = [")", "))", ")))", "))))"]
//列宽度
export const ColumnSize = [
  60,   //左括号
  240,  //数据
  80,   //比较符
  90,  //值
  60,   //右括号
  60,   //关系
  50    //新增和删除
];  